import {Component, OnInit} from '@angular/core';
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {Apollo} from "apollo-angular";
import {getAllServicesNavBar} from "../../../graphql/graphql.queris";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-services-list',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    RouterLink,
    NgOptimizedImage
  ],
  templateUrl: './services-list.component.html',
  styleUrl: './services-list.component.css'
})
export class ServicesListComponent implements OnInit{
  servicios: any[] = [
    {
      "name": "Farmacia",
      "icono": "farmacia/farmaciaBanner.svg",
      "url": "/farmacia",
      "imagenUrl": "farmacia/farmaciaBanner.png",
    },

    {
      "name": "Movilink",
      "icono": "home/MoviLink.svg",
      "url": "/movilink",
      "imagenUrl": "movilink/movilinkBanner.png",
    },
    {
      "name": "Onlink",
      "icono": "home/OnLink.svg",
      "url": "/onlink",
      "imagenUrl": "onlink/onlinkBanner.png",
    },
    {
      "name": "Terapia Física",
      "icono": "home/terapiaFisica.svg",
      "url": "/terapiafisica",
      "imagenUrl": "terapiaFisica/terapiaFisicaBanner.jpg",
    },
    {
      "name": "Imágenes",
      "icono": "imagenes/imagenes.svg",
      "url": "/imagenes",
      "imagenUrl": "imagenes/imagenesBanner.png",
    },{
      "name": "Laboratorio",
      "icono": "laboratorio/laboratorio.svg",
      "url": "/laboratorio",
      "imagenUrl": "laboratorio/laboratorioBanner.png",
    }
  ];
  serviciosVisibles: any[] = [];
  serviciosPorPagina = 6;
  paginaActual = 1;
  loading = true;
  error: any;

  constructor(
    private apollo: Apollo
  ) {
  }

  ngOnInit():void {

  }

  convertirPrimeraLetraMayuscula(texto: string): string {
    return texto.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  cargarMas(): void {
    const inicio = (this.paginaActual - 1) * this.serviciosPorPagina;
    const fin = this.paginaActual * this.serviciosPorPagina;
    this.serviciosVisibles = this.serviciosVisibles.concat(this.servicios.slice(inicio, fin));
    this.paginaActual++;
  }





}
